import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useI18n } from "@/contexts/I18nContext";
import CurrencyLanguageSelector from "@/components/CurrencyLanguageSelector";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_agent-command-50/artifacts/5l5kqqvg_logo_DNCM.png";

export default function Navbar() {
  const { t } = useI18n();
  const [menuOpen, setMenuOpen] = useState(false);
  // /agents page is no longer linked from the public navigation per spec.
  const links = [
    { to: "/vision", key: "nav_vision", testid: "nav-vision" },
    { to: "/vault", key: "nav_vault", testid: "nav-the-vault" },
    { to: "/studio", key: "nav_studio", testid: "nav-studio" },
    { to: "/cockpit", key: "nav_cockpit", testid: "nav-cockpit" },
  ];

  return (
    <header
      data-testid="dncm-navbar"
      className="fixed top-0 left-0 right-0 z-40 backdrop-blur-md"
      style={{
        background: "linear-gradient(180deg, rgba(5,5,5,0.92) 0%, rgba(5,5,5,0.55) 100%)",
        borderBottom: "1px solid var(--dncm-line)",
      }}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between gap-3">
        <Link to="/vision" data-testid="brand-link" className="flex items-center gap-3 group shrink-0">
          <img
            src={LOGO_URL}
            alt="DNCM Solution"
            className="h-9 w-9 object-contain"
            style={{ filter: "drop-shadow(0 0 14px rgba(0,207,255,0.45))" }}
          />
          <span className="font-display text-[15px] sm:text-base text-white group-hover:text-[color:var(--dncm-cyan)] transition-colors hidden sm:inline">
            DNCM <span className="text-white/45">Solution</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `dncm-link font-mono-d text-[11px] uppercase tracking-[0.22em] ${
                  isActive ? "dncm-active-link" : "text-white/75"
                }`
              }
            >
              {t(l.key)}
            </NavLink>
          ))}
        </nav>
        <a
          href="/ambassadeurs.html"
          data-testid="nav-ambassadeurs"
          className="hidden lg:inline-flex dncm-link font-mono-d text-[11px] uppercase tracking-[0.22em] text-white/75 hover:text-[color:var(--dncm-cyan)] transition-colors"
        >
          Ambassadeurs
        </a>

        <div className="flex items-center gap-2">
          <CurrencyLanguageSelector />
          <a
            href="/vision#agent-miroir"
            data-testid="nav-test-mirror"
            className="hidden md:inline-flex items-center gap-2 px-3 py-2 rounded-md font-mono-d text-[10px] uppercase tracking-[0.22em] dncm-mirror-btn"
          >
            {t("nav_test_mirror")}
          </a>
        <button
          className="lg:hidden flex flex-col justify-center items-center w-9 h-9 gap-1.5 rounded-md border border-white/10"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span className="block w-5 h-px bg-white"></span>
          <span className={menuOpen ? "hidden" : "block w-5 h-px bg-white"}></span>
          <span className="block w-5 h-px bg-white"></span>
        </button>
        </div>
      </div>
      {menuOpen && (
        <div className="lg:hidden border-t border-white/10 bg-[#080810] px-6 py-4 flex flex-col gap-3">
          <a href="/vision" onClick={() => setMenuOpen(false)} className="font-mono-d text-xs uppercase tracking-widest text-white/75 py-2 border-b border-white/10">Vision</a>
          <a href="/vault" onClick={() => setMenuOpen(false)} className="font-mono-d text-xs uppercase tracking-widest text-white/75 py-2 border-b border-white/10">The Vault</a>
          <a href="/studio" onClick={() => setMenuOpen(false)} className="font-mono-d text-xs uppercase tracking-widest text-white/75 py-2 border-b border-white/10">Studio</a>
          <a href="/cockpit" onClick={() => setMenuOpen(false)} className="font-mono-d text-xs uppercase tracking-widest text-white/75 py-2 border-b border-white/10">Cockpit</a>
          <a href="/ambassadeurs.html" onClick={() => setMenuOpen(false)} className="font-mono-d text-xs uppercase tracking-widest text-white/75 py-2 border-b border-white/10">Ambassadeurs</a>
        </div>
      )}
    </header>
  );
}
